<div class="bg-[#f7f7f7] flex flex-col items-center w-full overflow-x-hidden">
  <!-- ========== HERO ========== -->
  <section class="relative w-full max-w-[1440px] overflow-hidden min-h-[820px] lg:min-h-[900px]">
    <!-- Desktop floating lots -->
    <div
      class="hidden lg:block absolute left-5 top-[80px] -rotate-7 lot-shadow bg-white/95 rounded-[22px] p-2 w-[224px]">
      <div class="relative size-[208px] rounded-[15px] overflow-hidden">
        <img src="images/waitlist/lot-chronograph.png" alt="Field Chronograph" class="size-full object-cover" />
        <div class="absolute left-2 top-2 bg-primary flex gap-1.5 items-center pl-[7px] pr-2 py-[3px] rounded-full">
          <img src="icon/waitlist/live-dot.svg" alt="" class="size-[5px]" width="5" height="5" />
          <span class="font-semibold text-[11px] text-white">Live</span>
        </div>
        <div class="absolute right-2 top-2 bg-[#171717]/72 px-2 py-[3px] rounded-full">
          <span class="font-semibold text-[11px] text-white">⏱ 2:14:09</span>
        </div>
      </div>
      <div class="pt-2.5 px-1.5 pb-1 flex flex-col gap-0.5">
        <p class="font-medium text-[11px] text-[#a3a3a3] tracking-[0.66px] uppercase">Watches</p>
        <p class="font-semibold text-sm text-[#171717]">Field Chronograph</p>
        <div class="flex items-end justify-between pt-1.5">
          <div>
            <p class="font-medium text-[10px] text-[#a3a3a3] tracking-[0.6px] uppercase">Current bid</p>
            <p class="font-semibold text-[17px] text-[#171717] tracking-[-0.17px]">₦2,450,000</p>
          </div>
          <p class="font-medium text-[11px] text-[#5c5c5c]">17 bids</p>
        </div>
      </div>
    </div>

    <div
      class="hidden lg:block absolute left-[116px] top-[540px] rotate-5 lot-shadow bg-white/95 rounded-[19.5px] p-[7px] w-[200px] opacity-90 blur-[0.4px]">
      <div class="relative size-[185px] rounded-[13px] overflow-hidden">
        <img src="images/waitlist/lot-emerald.png" alt="Emerald & Diamond Set" class="size-full object-cover" />
        <div class="absolute left-[7px] top-[7px] bg-primary flex gap-1 items-center pl-1.5 pr-[7px] py-[3px] rounded-full">
          <img src="icon/waitlist/live-dot.svg" alt="" class="size-1" width="4" height="4" />
          <span class="font-semibold text-[10px] text-white">Live</span>
        </div>
        <div class="absolute right-[7px] top-[7px] bg-[#171717]/72 px-[7px] py-[3px] rounded-full">
          <span class="font-semibold text-[10px] text-white">⏱ 48:22</span>
        </div>
      </div>
      <div class="pt-2 px-1.5 pb-1 flex flex-col gap-0.5">
        <p class="font-medium text-[10px] text-[#a3a3a3] tracking-[0.6px] uppercase">Jewellery</p>
        <p class="font-semibold text-xs text-[#171717]">Emerald & Diamond Set</p>
        <div class="flex items-end justify-between pt-1">
          <div>
            <p class="font-medium text-[9px] text-[#a3a3a3] uppercase">Current bid</p>
            <p class="font-semibold text-[15px] text-[#171717]">₦1,180,000</p>
          </div>
          <p class="font-medium text-[10px] text-[#5c5c5c]">9 bids</p>
        </div>
      </div>
    </div>

    <div
      class="hidden lg:block absolute right-[75px] top-[81px] rotate-6 lot-shadow bg-white/95 rounded-[19px] p-[7px] w-[195px] opacity-80 blur-[0.5px]">
      <div class="relative size-[182px] rounded-[13px] overflow-hidden">
        <img src="images/waitlist/lot-vessel.png" alt="Hand-painted Vessel" class="size-full object-cover" />
        <div class="absolute left-[7px] top-[7px] bg-primary flex gap-1 items-center pl-1.5 pr-[7px] py-[3px] rounded-full">
          <img src="icon/waitlist/live-dot.svg" alt="" class="size-1" width="4" height="4" />
          <span class="font-semibold text-[10px] text-white">Live</span>
        </div>
        <div class="absolute right-[7px] top-[7px] bg-[#171717]/72 px-[7px] py-[3px] rounded-full">
          <span class="font-semibold text-[10px] text-white">⏱ 5:02:41</span>
        </div>
      </div>
      <div class="pt-2 px-1.5 pb-1 flex flex-col gap-0.5">
        <p class="font-medium text-[10px] text-[#a3a3a3] uppercase tracking-[0.6px]">Fine art</p>
        <p class="font-semibold text-xs text-[#171717]">Hand-painted Vessel</p>
        <div class="flex items-end justify-between pt-1">
          <div>
            <p class="font-medium text-[9px] text-[#a3a3a3] uppercase">Current bid</p>
            <p class="font-semibold text-[15px] text-[#171717]">₦860,000</p>
          </div>
          <p class="font-medium text-[10px] text-[#5c5c5c]">6 bids</p>
        </div>
      </div>
    </div>

    <div
      class="hidden lg:block absolute right-5 top-[484px] -rotate-5 lot-shadow bg-white/95 rounded-[22px] p-2 w-[224px]">
      <div class="relative size-[208px] rounded-[15px] overflow-hidden">
        <img src="images/waitlist/lot-pearl-watch.png" alt="Pearl Dial Dress Watch" class="size-full object-cover" />
        <div class="absolute left-2 top-2 bg-primary flex gap-1.5 items-center pl-[7px] pr-2 py-[3px] rounded-full">
          <img src="icon/waitlist/live-dot.svg" alt="" class="size-[5px]" width="5" height="5" />
          <span class="font-semibold text-[11px] text-white">Live</span>
        </div>
        <div class="absolute right-2 top-2 bg-[#171717]/72 px-2 py-[3px] rounded-full">
          <span class="font-semibold text-[11px] text-white">⏱ 09:58</span>
        </div>
      </div>
      <div class="pt-2.5 px-1.5 pb-1 flex flex-col gap-0.5">
        <p class="font-medium text-[11px] text-[#a3a3a3] tracking-[0.66px] uppercase">Watches</p>
        <p class="font-semibold text-sm text-[#171717]">Pearl Dial Dress Watch</p>
        <div class="flex items-end justify-between pt-1.5">
          <div>
            <p class="font-medium text-[10px] text-[#a3a3a3] tracking-[0.6px] uppercase">Current bid</p>
            <p class="font-semibold text-[17px] text-[#171717] tracking-[-0.17px]">₦3,900,000</p>
          </div>
          <p class="font-medium text-[11px] text-[#5c5c5c]">24 bids</p>
        </div>
      </div>
    </div>

    <!-- Stickers (desktop) -->
    <div
      class="hidden lg:flex absolute left-[100px] top-[496px] -rotate-9 sticker-shadow bg-[#171717] gap-2 items-center pl-3.5 pr-4 py-2.5 rounded-full z-10">
      <img src="icon/waitlist/shield-check.svg" alt="" class="size-[18px]" width="18" height="18" />
      <span class="font-bold text-[15px] text-white tracking-[-0.15px]">Held in escrow</span>
    </div>
    <div
      class="hidden lg:flex absolute right-[56px] top-[455px] rotate-7 sticker-shadow bg-[#ffe45c] gap-2 items-center pl-3.5 pr-4 py-2.5 rounded-full z-10">
      <img src="icon/waitlist/truck.svg" alt="" class="size-[18px]" width="18" height="18" />
      <span class="font-bold text-[15px] text-[#171717] tracking-[-0.15px]">Delivered to your door</span>
    </div>

    <!-- Nav -->
    <nav
      class="absolute z-20 left-4 right-4 top-4 lg:left-1/2 lg:right-auto lg:-translate-x-1/2 lg:w-[720px] nav-glass border border-[#ebebeb] flex items-center justify-between pl-3.5 lg:pl-5 pr-1.5 lg:pr-2 py-1.5 lg:py-2 rounded-full">
      <img src="icon/waitlist/logo.svg" alt="Lumina" class="h-7 w-auto" width="101" height="28" />
      <div class="hidden lg:flex gap-2 items-center">
        <img src="icon/waitlist/opening-dot.svg" alt="" class="size-[7px]" width="7" height="7" />
        <span class="font-medium text-[13px] text-[#5c5c5c]">Opening soon</span>
      </div>
      <button
        type="button"
        class="bg-primary flex items-center justify-center p-2.5 rounded-full cursor-pointer border-0"
        (click)="scrollToForm()">
        <span class="font-medium text-sm leading-5 tracking-[-0.084px] text-white px-1 whitespace-nowrap">
          Join the waitlist
        </span>
      </button>
    </nav>

    <!-- Hero copy -->
    <div
      class="absolute z-10 left-4 right-4 top-[108px] lg:left-1/2 lg:right-auto lg:-translate-x-1/2 lg:top-[276px] flex flex-col gap-5 lg:gap-6 items-center">
      <div
        class="bg-white/80 border border-[#ebebeb] flex gap-2.5 items-center pl-3 pr-3.5 py-[7px] rounded-full">
        <img src="icon/waitlist/opening-dot.svg" alt="" class="size-[7px]" width="7" height="7" />
        <p class="font-medium text-sm text-[#5c5c5c] whitespace-nowrap">
          A new kind of auction house · Nigeria
        </p>
      </div>

      <div class="flex flex-col items-center text-center">
        <!-- Desktop headline with photo pill -->
        <div class="hidden lg:flex flex-col items-center">
          <div class="flex gap-[18px] items-center mb-[-4px]">
            <h1 class="font-semibold text-[88px] leading-none tracking-[-3.96px] text-[#171717]">The auction</h1>
            <div class="rotate-4 border-[3px] border-white h-[72px] w-[132px] rounded-full overflow-hidden shadow-[0px_8px_20px_-6px_rgba(0,0,0,0.25)] shrink-0">
              <img src="images/waitlist/lot-emerald.png" alt="" class="size-full object-cover" />
            </div>
            <h1 class="font-semibold text-[88px] leading-none tracking-[-3.96px] text-[#171717]">house</h1>
          </div>
          <div class="flex gap-5 items-baseline">
            <span class="font-semibold text-[88px] leading-none tracking-[-3.96px] text-[#171717]">in your</span>
            <span class="font-script text-[96px] leading-none tracking-[-1.92px] text-primary">pocket.</span>
          </div>
        </div>
        <!-- Mobile headline -->
        <div class="flex lg:hidden flex-col items-center">
          <h1 class="font-semibold text-[44px] leading-none tracking-[-1.98px] text-[#171717] mb-[-4px]">
            The auction house
          </h1>
          <div class="flex gap-2.5 items-baseline">
            <span class="font-semibold text-[44px] leading-none tracking-[-1.98px] text-[#171717]">in your</span>
            <span class="font-script text-[48px] leading-none tracking-[-0.96px] text-primary">pocket.</span>
          </div>
        </div>
      </div>

      <p class="font-normal text-[17px] lg:text-[19px] leading-[1.5] text-[#5c5c5c] text-center max-w-[343px] lg:max-w-[560px]">
        LUMINA is a mobile-first auction marketplace for buying and selling high-value items — watches, bags, fine art
        and more.
      </p>

      <div class="flex flex-col lg:flex-row gap-3.5 lg:gap-5 items-center">
        <button
          type="button"
          class="bg-primary flex gap-[5px] items-center justify-center p-[13px] rounded-full cursor-pointer border-0"
          (click)="scrollToForm()">
          <span class="font-medium text-[18px] leading-[26px] tracking-[-0.11px] text-white px-[5px]">
            Join the waitlist
          </span>
          <img src="icon/waitlist/arrow-right.svg" alt="" class="size-[26px]" width="26" height="26" />
        </button>
        <div class="flex gap-2 items-center">
          <img src="icon/waitlist/wallet.svg" alt="" class="size-4" width="16" height="16" />
          <p class="font-medium text-sm text-[#5c5c5c]">Wallet powered by Advancly</p>
        </div>
      </div>
    </div>

    <!-- Mobile lot fan -->
    <div class="lg:hidden absolute left-0 right-0 top-[472px] h-[300px] pointer-events-none">
      <div class="absolute left-0 top-0 -rotate-12 lot-shadow bg-white rounded-[18px] p-[7px] w-[188px]">
        <div class="relative size-[175px] rounded-[13px] overflow-hidden">
          <img src="images/waitlist/lot-emerald.png" alt="" class="size-full object-cover" />
          <div class="absolute left-1.5 top-1.5 bg-primary flex gap-1 items-center px-1.5 py-0.5 rounded-full">
            <span class="font-semibold text-[9px] text-white">Live</span>
          </div>
        </div>
        <div class="pt-2 px-1">
          <p class="font-medium text-[9px] text-[#a3a3a3] uppercase">Jewellery</p>
          <p class="font-semibold text-[12px] text-[#171717]">Emerald & Diamond Set</p>
          <p class="font-semibold text-sm text-[#171717] pt-1">₦1,180,000</p>
        </div>
      </div>
      <div class="absolute left-[136px] top-10 rotate-11 lot-shadow bg-white rounded-[18px] p-[7px] w-[188px] z-[1]">
        <div class="relative size-[175px] rounded-[13px] overflow-hidden">
          <img src="images/waitlist/lot-pearl-watch.png" alt="" class="size-full object-cover" />
          <div class="absolute left-1.5 top-1.5 bg-primary flex gap-1 items-center px-1.5 py-0.5 rounded-full">
            <span class="font-semibold text-[9px] text-white">Live</span>
          </div>
        </div>
        <div class="pt-2 px-1">
          <p class="font-medium text-[9px] text-[#a3a3a3] uppercase">Watches</p>
          <p class="font-semibold text-[12px] text-[#171717]">Pearl Dial Dress Watch</p>
          <p class="font-semibold text-sm text-[#171717] pt-1">₦3,900,000</p>
        </div>
      </div>
      <div
        class="absolute left-1/2 -translate-x-1/2 top-2 lot-shadow bg-white rounded-[18px] p-[7px] w-[200px] z-[2]">
        <div class="relative size-[175px] mx-auto rounded-[13px] overflow-hidden">
          <img src="images/waitlist/lot-chronograph.png" alt="Field Chronograph" class="size-full object-cover" />
          <div class="absolute left-1.5 top-1.5 bg-primary flex gap-1 items-center px-1.5 py-0.5 rounded-full">
            <span class="font-semibold text-[9px] text-white">Live</span>
          </div>
          <div class="absolute right-1.5 top-1.5 bg-[#171717]/72 px-1.5 py-0.5 rounded-full">
            <span class="font-semibold text-[9px] text-white">⏱ 2:14:09</span>
          </div>
        </div>
        <div class="pt-2 px-1">
          <p class="font-medium text-[9px] text-[#a3a3a3] uppercase">Watches</p>
          <p class="font-semibold text-[12px] text-[#171717]">Field Chronograph</p>
          <div class="flex justify-between items-end pt-1">
            <p class="font-semibold text-[15px] text-[#171717]">₦2,450,000</p>
            <p class="font-medium text-[9px] text-[#5c5c5c]">17 bids</p>
          </div>
        </div>
      </div>
      <!-- Mobile stickers -->
      <div
        class="absolute left-3 top-[-8px] -rotate-6 sticker-shadow bg-[#171717] gap-1.5 items-center pl-2.5 pr-3 py-1.5 rounded-full z-[3] flex pointer-events-auto">
        <img src="icon/waitlist/shield-check.svg" alt="" class="size-3.5" width="14" height="14" />
        <span class="font-bold text-xs text-white">Held in escrow</span>
      </div>
      <div
        class="absolute right-2 bottom-8 rotate-6 sticker-shadow bg-[#ffe45c] gap-1.5 items-center pl-2.5 pr-3 py-1.5 rounded-full z-[3] flex pointer-events-auto">
        <img src="icon/waitlist/truck.svg" alt="" class="size-3.5" width="14" height="14" />
        <span class="font-bold text-xs text-[#171717]">Delivered to your door</span>
      </div>
    </div>
  </section>

  <!-- ========== WHY JOIN EARLY ========== -->
  <section class="w-full max-w-[1200px] px-4 lg:px-0 pt-16 lg:pt-[120px] flex flex-col gap-6 items-start">
    <p class="font-semibold text-[13px] text-primary tracking-[1.3px]">WHY JOIN EARLY</p>

    <div
      class="flex flex-wrap gap-x-2.5 lg:gap-x-3.5 gap-y-2 lg:gap-y-1.5 items-center content-center max-w-[1120px]">
      <p class="font-medium text-[28px] lg:text-[58px] leading-[1.16] tracking-[-0.5px] lg:tracking-[-1.74px] text-[#171717]">
        Get in before the doors open. Waitlist members bid first on
      </p>
      <span
        class="bg-white border border-[#ebebeb] inline-flex gap-2 lg:gap-3 items-center pl-1 pr-3 lg:pr-5 py-0.5 rounded-full shadow-[0px_6px_16px_-10px_rgba(0,0,0,0.15)]">
        <img src="images/waitlist/chip-watch.png" alt="" class="size-8 lg:size-14 rounded-full object-cover" />
        <span class="font-medium text-[28px] lg:text-[58px] leading-[1.16] tracking-[-0.5px] lg:tracking-[-1.74px] text-[#171717]">watches,</span>
      </span>
      <span
        class="bg-white border border-[#ebebeb] inline-flex gap-2 lg:gap-3 items-center pl-1 pr-3 lg:pr-5 py-0.5 rounded-full shadow-[0px_6px_16px_-10px_rgba(0,0,0,0.15)]">
        <img src="images/waitlist/chip-jewellery.png" alt="" class="size-8 lg:size-14 rounded-full object-cover" />
        <span class="font-medium text-[28px] lg:text-[58px] leading-[1.16] tracking-[-0.5px] lg:tracking-[-1.74px] text-[#171717]">jewellery</span>
      </span>
      <p class="font-medium text-[28px] lg:text-[58px] leading-[1.16] tracking-[-0.5px] lg:tracking-[-1.74px] text-[#171717]">and</p>
      <span
        class="bg-white border border-[#ebebeb] inline-flex gap-2 lg:gap-3 items-center pl-1 pr-3 lg:pr-5 py-0.5 rounded-full shadow-[0px_6px_16px_-10px_rgba(0,0,0,0.15)]">
        <img src="images/waitlist/chip-art.png" alt="" class="size-8 lg:size-14 rounded-full object-cover" />
        <span class="font-medium text-[28px] lg:text-[58px] leading-[1.16] tracking-[-0.5px] lg:tracking-[-1.74px] text-[#171717]">fine art</span>
      </span>
      <p class="font-medium text-[28px] lg:text-[58px] leading-[1.16] tracking-[-0.5px] lg:tracking-[-1.74px] text-[#d1d1d1]">
        — every payment
      </p>
      <span
        class="bg-white border border-[#ebebeb] inline-flex gap-2 lg:gap-3 items-center pl-3 lg:pl-4 pr-3 lg:pr-5 py-0.5 rounded-full shadow-[0px_6px_16px_-10px_rgba(0,0,0,0.15)]">
        <img src="icon/waitlist/lock.svg" alt="" class="size-7 lg:size-10" width="40" height="40" />
        <span class="font-medium text-[28px] lg:text-[58px] leading-[1.16] tracking-[-0.5px] lg:tracking-[-1.74px] text-[#d1d1d1]">held in escrow,</span>
      </span>
      <p class="font-medium text-[28px] lg:text-[58px] leading-[1.16] tracking-[-0.5px] lg:tracking-[-1.74px] text-[#d1d1d1]">
        every win
      </p>
      <span
        class="bg-white border border-[#ebebeb] inline-flex gap-2 lg:gap-3 items-center pl-3 lg:pl-4 pr-3 lg:pr-5 py-0.5 rounded-full shadow-[0px_6px_16px_-10px_rgba(0,0,0,0.15)]">
        <img src="icon/waitlist/truck-muted.svg" alt="" class="size-7 lg:size-10" width="40" height="40" />
        <span class="font-medium text-[28px] lg:text-[58px] leading-[1.16] tracking-[-0.5px] lg:tracking-[-1.74px] text-[#d1d1d1]">delivered to your door.</span>
      </span>
    </div>

    <!-- Bento -->
    <div class="w-full flex flex-col lg:flex-row gap-4 items-stretch pt-8 lg:pt-12">
      <!-- 01 First access -->
      <div class="bg-[#171717] rounded-[32px] overflow-hidden relative min-h-[420px] lg:min-h-[616px] lg:w-[493px] shrink-0 p-8">
        <div class="flex flex-col items-start max-w-[340px] relative z-10">
          <p class="font-semibold text-[13px] text-white/55">01</p>
          <p class="font-semibold text-[28px] leading-[1.15] tracking-[-0.56px] text-white mt-3">First access</p>
          <p class="font-normal text-base leading-[1.5] text-[#a3a3a3] mt-2.5">
            Waitlist members get in first when LUMINA launches — before bidding opens to everyone.
          </p>
        </div>
        <div class="absolute left-1/2 -translate-x-1/4 bottom-[-20px] lg:left-[132px] lg:translate-x-0 lg:top-[225px] -rotate-8 flex flex-col items-center">
          <div
            class="size-[180px] lg:size-[210px] rounded-full bg-primary flex flex-col gap-2.5 items-center justify-center shadow-[0px_30px_60px_-20px_rgba(212,20,90,0.7)] relative">
            <img src="icon/waitlist/logo-mark.svg" alt="" class="size-12" width="48" height="48" />
            <p class="font-bold text-[15px] text-white text-center tracking-[1.2px] leading-[1.15]">
              EARLY<br />ACCESS
            </p>
            <div class="absolute inset-0 rounded-full shadow-[inset_0px_-10px_24px_0px_rgba(0,0,0,0.25)] pointer-events-none"></div>
          </div>
          <div class="bg-[#262626] h-[120px] lg:h-[150px] w-[30px] rounded-b-[15px] -mt-2"></div>
        </div>
      </div>

      <div class="flex flex-col gap-4 flex-1 min-w-0">
        <!-- 02 Money protected -->
        <div
          class="bg-primary rounded-[32px] overflow-hidden flex flex-col lg:flex-row items-start lg:items-center justify-between gap-6 px-8 py-8 lg:h-[300px]">
          <div class="flex flex-col items-start max-w-[280px] shrink-0">
            <p class="font-semibold text-[13px] text-white/55">02</p>
            <p class="font-semibold text-[28px] leading-[1.15] tracking-[-0.56px] text-white mt-3">
              Your money is protected
            </p>
            <p class="font-normal text-base leading-[1.5] text-white/85 mt-2.5">
              Payment sits in escrow until your item arrives. Your wallet is powered by Advancly.
            </p>
          </div>
          <div class="rotate-3 bg-white/95 rounded-[22px] p-4 flex flex-col gap-3 w-full max-w-[290px] shadow-[0px_30px_60px_-24px_rgba(61,0,20,0.6)]">
            <div class="flex gap-3 items-center border-b border-dashed border-[#d1d1d1] pb-3.5">
              <div class="bg-[#fdf2f6] size-10 rounded-xl flex items-center justify-center shrink-0">
                <img src="icon/waitlist/lock-pink.svg" alt="" class="size-5" width="20" height="20" />
              </div>
              <div>
                <p class="font-normal text-xs text-[#5c5c5c]">Held in escrow</p>
                <p class="font-semibold text-[22px] tracking-[-0.44px] text-[#171717]">₦2,450,000</p>
              </div>
            </div>
            <div class="flex gap-2.5 items-center">
              <div class="size-[22px] rounded-full bg-[#1fc16b] flex items-center justify-center text-white text-[13px] font-bold">✓</div>
              <p class="font-medium text-sm text-[#171717]">You win & pay</p>
            </div>
            <div class="flex gap-2.5 items-center">
              <div class="size-[22px] rounded-full bg-[#1fc16b] flex items-center justify-center text-white text-[13px] font-bold">✓</div>
              <p class="font-medium text-sm text-[#171717]">Funds held safely</p>
            </div>
            <div class="flex gap-2.5 items-center">
              <div class="size-[22px] rounded-full border-[1.5px] border-primary shrink-0"></div>
              <p class="font-medium text-sm text-[#171717]">Item delivered</p>
            </div>
            <div class="flex gap-2.5 items-center">
              <div class="size-[22px] rounded-full border-[1.5px] border-[#d1d1d1] shrink-0"></div>
              <p class="font-medium text-sm text-[#a3a3a3]">Seller gets paid</p>
            </div>
          </div>
        </div>

        <!-- 03 Delivered -->
        <div
          class="bg-white border border-[#ebebeb] rounded-[32px] overflow-hidden flex flex-col lg:flex-row items-start lg:items-center justify-between gap-6 px-8 py-8 lg:h-[300px]">
          <div class="flex flex-col items-start max-w-[280px] shrink-0">
            <p class="font-semibold text-[13px] text-[#5c5c5c]/55">03</p>
            <p class="font-semibold text-[28px] leading-[1.15] tracking-[-0.56px] text-[#171717] mt-3">
              Delivered for you
            </p>
            <p class="font-normal text-base leading-[1.5] text-[#5c5c5c] mt-2.5">
              We collect from the seller and deliver straight to the winning bidder.
            </p>
          </div>
          <div class="-rotate-2 bg-[#f7f7f7] border border-[#ebebeb] rounded-[22px] p-4 flex flex-col gap-3 w-full max-w-[300px]">
            <div class="flex justify-between items-start">
              <p class="font-normal text-xs text-[#5c5c5c]">Tracking no.</p>
              <p class="font-semibold text-sm text-[#171717]">LUM 2748 1093</p>
            </div>
            <div class="relative h-[52px] w-full max-w-[256px]">
              <div class="absolute bg-[#ebebeb] h-1 left-0 top-[34px] w-full rounded"></div>
              <div class="absolute bg-primary h-1 left-0 top-[34px] w-[67%] rounded"></div>
              <img src="icon/waitlist/track-dot.svg" alt="" class="absolute left-0 top-[29px] size-3.5" width="14" height="14" />
              <img src="icon/waitlist/track-dot.svg" alt="" class="absolute left-[30%] top-[29px] size-3.5" width="14" height="14" />
              <img src="icon/waitlist/track-dot.svg" alt="" class="absolute left-[64%] top-[29px] size-3.5" width="14" height="14" />
              <img src="icon/waitlist/track-dot-muted.svg" alt="" class="absolute right-0 top-[29px] size-3.5" width="14" height="14" />
              <div class="absolute left-[58%] top-[-2px] bg-[#171717] size-[30px] rounded-[10px] flex items-center justify-center">
                <img src="icon/waitlist/truck-white.svg" alt="" class="size-4" width="16" height="16" />
              </div>
            </div>
            <div class="flex justify-between font-medium text-[11px] text-[#5c5c5c]">
              <span>Booked</span>
              <span>Picked up</span>
              <span>In transit</span>
              <span>Delivered</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- ========== SIGNUP ========== -->
  <section id="waitlist-form" class="w-full max-w-[1200px] px-4 lg:px-0 pt-16 lg:pt-[160px] pb-16 lg:pb-[120px]">
    <p class="lg:hidden font-semibold text-[13px] text-primary tracking-[1.3px] mb-4">THE WAITLIST</p>
    <div
      class="bg-[#171717] rounded-[32px] lg:rounded-[40px] flex flex-col lg:flex-row gap-10 lg:gap-16 items-stretch lg:items-center px-6 py-10 lg:pl-[72px] lg:pr-12 lg:py-14">
      <div class="hidden lg:flex flex-1 flex-col gap-5 items-start min-w-0">
        <p class="font-semibold text-[13px] text-primary tracking-[1.3px]">THE WAITLIST</p>
        <div class="flex flex-col items-start leading-none">
          <p class="font-semibold text-[84px] tracking-[-3.78px] text-white mb-[-6px]">Raise your</p>
          <p class="font-script text-[92px] tracking-[-1.84px] text-[#ff5a93]">paddle.</p>
        </div>
        <p class="font-normal text-lg leading-[1.5] text-[#a3a3a3] max-w-[380px]">
          Leave your details and we’ll let you in first when LUMINA launches.
        </p>
      </div>

      <form
        class="bg-white rounded-[28px] p-6 lg:p-8 flex flex-col gap-5 w-full lg:w-[480px] shrink-0 shadow-[0px_40px_80px_-30px_rgba(0,0,0,0.6)]"
        [formGroup]="form"
        (ngSubmit)="submitWaitlist()">
        <div class="lg:hidden">
          <p class="font-semibold text-[36px] tracking-[-1.5px] text-[#171717] leading-none">
            Raise your <span class="font-script text-[40px] text-[#ff5a93]">paddle.</span>
          </p>
          <p class="font-normal text-sm text-[#5c5c5c] mt-3 leading-[1.5]">
            Leave your details and we’ll let you in first when LUMINA launches.
          </p>
        </div>

        <div class="flex flex-col gap-1 w-full">
          <label class="font-medium text-sm leading-5 tracking-[-0.084px] text-[#171717]">
            Full name <span class="text-primary">*</span>
          </label>
          <div
            class="bg-white border flex gap-2 items-center pl-3 pr-2.5 py-2.5 rounded-[10px] shadow-[0px_1px_2px_0px_rgba(10,13,20,0.03)]"
            [class.border-[#ebebeb]]="!showError('fullName')"
            [class.border-error-base]="showError('fullName')"
            [class.ring-1]="showError('fullName')"
            [class.ring-error-base]="showError('fullName')">
            <img src="icon/waitlist/user.svg" alt="" class="size-5 shrink-0" width="20" height="20" />
            <input
              type="text"
              formControlName="fullName"
              placeholder="e.g. Ada Okafor"
              autocomplete="name"
              class="flex-1 min-w-0 border-0 outline-none bg-transparent font-medium text-sm leading-5 tracking-[-0.084px] text-[#171717] placeholder:text-[#a3a3a3]" />
          </div>
          @if (showError('fullName')) {
            <p class="text-xs text-error-base mt-0.5">{{ errorMessage('fullName') }}</p>
          }
        </div>

        <div class="flex flex-col gap-1 w-full">
          <label class="font-medium text-sm leading-5 tracking-[-0.084px] text-[#171717]">
            Email address <span class="text-primary">*</span>
          </label>
          <div
            class="bg-white border flex gap-2 items-center pl-3 pr-2.5 py-2.5 rounded-[10px] shadow-[0px_1px_2px_0px_rgba(10,13,20,0.03)]"
            [class.border-[#ebebeb]]="!showError('email')"
            [class.border-error-base]="showError('email')"
            [class.ring-1]="showError('email')"
            [class.ring-error-base]="showError('email')">
            <img src="icon/waitlist/mail.svg" alt="" class="size-5 shrink-0" width="20" height="20" />
            <input
              type="email"
              formControlName="email"
              placeholder="you@example.com"
              autocomplete="email"
              class="flex-1 min-w-0 border-0 outline-none bg-transparent font-medium text-sm leading-5 tracking-[-0.084px] text-[#171717] placeholder:text-[#a3a3a3]" />
          </div>
          @if (showError('email')) {
            <p class="text-xs text-error-base mt-0.5">{{ errorMessage('email') }}</p>
          }
        </div>

        <div class="flex flex-col gap-1 w-full">
          <label class="font-medium text-sm leading-5 tracking-[-0.084px] text-[#171717]">
            Phone number <span class="text-primary">*</span>
          </label>
          <div
            class="bg-white border flex items-stretch overflow-hidden rounded-[10px] shadow-[0px_1px_2px_0px_rgba(10,13,20,0.03)]"
            [class.border-[#ebebeb]]="!showError('phoneNumber')"
            [class.border-error-base]="showError('phoneNumber')"
            [class.ring-1]="showError('phoneNumber')"
            [class.ring-error-base]="showError('phoneNumber')">
            <div class="flex gap-2 items-center pl-2.5 pr-2 py-2.5 shrink-0">
              <img src="icon/waitlist/nigeria.svg" alt="" class="size-5" width="20" height="20" />
              <span class="font-medium text-sm text-[#171717] tracking-[-0.084px]">+234</span>
              <img src="icon/waitlist/arrow-down.svg" alt="" class="size-5" width="20" height="20" />
            </div>
            <div class="border-l border-[#ebebeb] flex flex-1 items-center pl-3 pr-2.5 py-2.5 min-w-0">
              <input
                type="tel"
                formControlName="phoneNumber"
                placeholder="801 234 5678"
                autocomplete="tel-national"
                class="w-full border-0 outline-none bg-transparent font-medium text-sm leading-5 tracking-[-0.084px] text-[#171717] placeholder:text-[#a3a3a3]" />
            </div>
          </div>
          @if (showError('phoneNumber')) {
            <p class="text-xs text-error-base mt-0.5">{{ errorMessage('phoneNumber') }}</p>
          }
        </div>

        <button
          type="submit"
          class="bg-primary flex items-center justify-center p-2.5 rounded-full w-full cursor-pointer border-0 disabled:opacity-60"
          [disabled]="sending()">
          <span class="font-medium text-sm leading-5 tracking-[-0.084px] text-white px-1">
            {{ sending() ? 'Joining…' : 'Join the waitlist' }}
          </span>
        </button>

        @if (sendSuccess()) {
          <p class="text-sm text-[#1fc16b]">You’re on the list. We’ll be in touch at launch.</p>
        }
        @if (sendError()) {
          <p class="text-sm text-error-base">{{ sendError() }}</p>
        }

        <p class="font-normal text-[13px] leading-[1.5] text-[#a3a3a3]">
          We’ll only use this to contact you about launch. See our
          <a routerLink="/privacy-policy" class="text-[#5c5c5c] underline underline-offset-2">Privacy Policy</a>.
        </p>
      </form>
    </div>
  </section>

  <!-- ========== FOOTER ========== -->
  <footer class="w-full max-w-[1200px] px-4 lg:px-0 flex flex-col gap-6 items-start overflow-hidden pb-0">
    <div class="border-t border-[#d1d1d1] flex items-start justify-between pt-6 w-full text-sm text-[#5c5c5c]">
      <p>© 2026 LUMINA</p>
      <a href="mailto:support@lumina.ng" class="hover:text-[#171717]">support&#64;lumina.ng</a>
    </div>
    <div class="relative w-full h-[120px] lg:h-[270px] overflow-hidden">
      <img
        src="icon/waitlist/wordmark.svg"
        alt=""
        class="absolute inset-0 w-full h-full object-cover object-top pointer-events-none select-none"
        width="1200"
        height="270" />
    </div>
  </footer>
</div>
